"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFooterConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BC_FOOTER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-footer");
var BC_FOOTER_CONSTANTS_NUMBERS = {
    N768: 768,
};
var BcFooterConstants = (function () {
    function BcFooterConstants() {
    }
    BcFooterConstants.BC_FOOTER = "".concat(BC_FOOTER);
    BcFooterConstants.BC_FOOTER_TOP = "".concat(BC_FOOTER, "-top");
    BcFooterConstants.BC_FOOTER_TOP_LINKS = "".concat(BC_FOOTER, "-top-links");
    BcFooterConstants.BC_FOOTER_MD_TABLET = BC_FOOTER_CONSTANTS_NUMBERS.N768;
    BcFooterConstants.BC_FOOTER_TOP_CONTAINERS = "".concat(BC_FOOTER, "-top-container");
    BcFooterConstants.BC_FOOTER_TOP_CONTAINER_TITLE = "".concat(BC_FOOTER, "-top-container-t");
    BcFooterConstants.BC_FOOTER_TOP_CONTAINER_CONTENT = "".concat(BC_FOOTER, "-top-container-p");
    BcFooterConstants.BC_FOOTER_COLUMN_LINKS_MOBILE = "".concat(BC_FOOTER, "-links-mobile");
    BcFooterConstants.BC_FOOTER_DIVIDER = "".concat(BC_FOOTER, "-divisor");
    BcFooterConstants.BC_ICON_CLASSES = ['bc-icon', 'bc-sm', 'bc-toggle-button'];
    BcFooterConstants.BC_FOOTER_ACCORDION_PREFIX = "".concat(BC_FOOTER, "-accordion");
    BcFooterConstants.BC_FOOTER_ACCORDIONS_GROUP = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordions-group");
    BcFooterConstants.BC_FOOTER_ACCORDION = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion");
    BcFooterConstants.BC_FOOTER_ACCORDION_TYPE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-minimal-unbordered");
    BcFooterConstants.BC_FOOTER_ACCORDION_HEADER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-header");
    BcFooterConstants.BC_FOOTER_ACCORDION_HEADER_TITLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-title");
    BcFooterConstants.BC_FOOTER_ACCORDION_HEADER_LEFT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-header-left");
    BcFooterConstants.BC_FOOTER_ACCORDION_HEADER_RIGHT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-header-right");
    BcFooterConstants.BC_FOOTER_ACCORDION_TEXT_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-text-container");
    BcFooterConstants.BC_FOOTER_ACCORDION_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-content");
    BcFooterConstants.BC_FOOTER_ACCORDION_ARROW = 'arrow2-down';
    BcFooterConstants.BC_FOOTER_STROKE = "".concat(BC_FOOTER, "-stroke");
    return BcFooterConstants;
}());
exports.BcFooterConstants = BcFooterConstants;
